export const TITLE = 'Velkommen til!';
export const REGISTER_USER = 'Opret bruger';
export const NAME = 'Navn';
export const EMAIL = 'E-mail';
export const PASSWORD = 'Adgangskode';
